import { useLocation } from 'react-router-dom';
import { layoutPath } from '../utils';

export const useLeaderBoard = () => {
  return { isLeaderBoard: useLocation().pathname.toLowerCase() === layoutPath('/leaderboard') };
};
